import React from 'react'
import {makeStyles} from '@mui/styles';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import {Button, CardActionArea, Icon, Typography} from '@mui/material';
import {AccessTime, Face, Kitchen, Visibility} from '@mui/icons-material';
import MenuIcon from "../../../Toolbar/Menu/CardMenu";


const useStyles = makeStyles(theme => ({
    card: {
        width: 500,
        margin: 30,
        borderRadius: 20,

    },
    CardContent: {
        display: 'flex',
        padding: '10%',
    },
    media: {
        display: 'Block',
        margin: 'auto',
        width: 200,
        height: 225,
        borderRadius: 20,
    },
    mediaDetails: {
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        display: 'flex',
        justifyContent: 'space-around',
        background: '#F0F0F0',
    },
    mediaDetail: {

        paddingTop: 10,
        width: 35,
        textAlign: 'center',
        flexDirection: 'column',
    },
    about: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flexGrow: 1,
        marginBottom: 10
    },
    left: {
        borderRadius: 20,
        flexBasis: '33.33%',
        display: 'flex',
    },
    right: {
        flex: 1,

        flexDirection: 'column',
        paddingLeft: 20,
        display: 'flex',

    },
}));

export default function PresentableRecipeCardBig({
                                                     commands,
                                                     recipe,
                                                     basketClick,
                                                     recipeClick,
                                                     userClick,
                                                     update,
                                                     inBasket
                                                 }) {
    const classes = useStyles();
    const {recipeName, timeInMinutes, imageData, views, ingredients, reqPortions} = recipe

    return (
        <Card variant="outlined" className={classes.card}>
            <CardActionArea onClick={recipeClick}>
                <div className={classes.CardContent} style={{display: 'flex', padding: '10%'}}>
                    <div className={classes.left}>
                        <CardMedia
                            className={classes.media}
                            image={imageData}
                            title={recipeName}
                        >
                            <div className={classes.mediaDetails}>
                                <div className={classes.mediaDetail}>
                                    <Icon color="secondary">
                                        <AccessTime/>
                                    </Icon>
                                    <Typography>{timeInMinutes}</Typography>
                                </div>
                                <div className={classes.mediaDetail}>
                                    <Icon color="secondary">
                                        <Kitchen/>
                                    </Icon>
                                    <Typography>{ingredients.length}</Typography>
                                </div>
                                <div className={classes.mediaDetail}>
                                    <Icon color="secondary">
                                        <Visibility/>
                                    </Icon>
                                    <Typography>{views}</Typography>
                                </div>
                                <div className={classes.mediaDetail}>
                                    <Icon color="secondary">
                                        <Face/>
                                    </Icon>
                                    <Typography>{reqPortions}</Typography>
                                </div>
                            </div>
                        </CardMedia>
                    </div>
                    <div className={classes.right}>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                            <Typography variant="h6" color="textPrimary" component="p">
                                {recipeName}
                            </Typography>
                            <div onClick={(e) => e.stopPropagation()}>
                                <MenuIcon recipe={recipe} commands={commands}/>
                            </div>
                        </div>
                        <Button onClick={(e) => { e.stopPropagation(); userClick(recipe.user.id); }}>
                            <Typography variant="caption" color="textPrimary" component="p">
                                Recipe By: {recipe.user ? recipe.user.username : "N/A"}
                            </Typography>
                        </Button>
                        <Typography className={classes.about} variant="body2" color="textSecondary" component="p">
                            {recipe.about}
                        </Typography>
                    </div>
                </div>
            </CardActionArea>
        </Card>
    )
}
